module.exports = __webpack_public_path__ + "static/media/hall-PA.f1520328.svg";